import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { CountryPrefixEnum } from 'Jsx/CheckoutV4/types';
import { DocumentTypeEnum } from 'Jsx/Types/Graphql/globals.payments';

import {
  getBrasilIdentityDocument,
  getArgentinaIdentityDocument,
  getColombiaIdentityDocument,
} from './formatIdentityDocument';

const getIdentityDocument = ({
  country,
  inputEvent,
  documentType,
}: {
  country: string;
  inputEvent: React.ChangeEvent<HTMLInputElement>;
  documentType?: DocumentTypeEnum;
}): {
  identityDocument: string;
  isIdentityDocumentValid: boolean;
  identityDocumentErrorMessage: string;
  identityDocumentDigits: number;
} => {
  const { value } = inputEvent.target;

  if (country === CountryPrefixEnum.BRASIL) {
    return getBrasilIdentityDocument(inputEvent);
  }
  if (country === CountryPrefixEnum.ARGENTINA) {
    return getArgentinaIdentityDocument(inputEvent);
  }
  if (country === CountryPrefixEnum.COLOMBIA) {
    return getColombiaIdentityDocument(inputEvent, documentType);
  }

  return {
    identityDocument: value.replace(/\D/, ''),
    isIdentityDocumentValid: !!(value && value.length > 7),
    identityDocumentErrorMessage: '',
    identityDocumentDigits: 8,
  };
};

export default getIdentityDocument;

export const validateIdentityDocument = ({
  country,
  inputEvent,
  documentType,
}: {
  country: string;
  inputEvent: React.ChangeEvent<HTMLInputElement>;
  documentType?: DocumentTypeEnum;
}): {
  identityDocument: string;
  isIdentityDocumentValid: boolean;
  identityDocumentErrorMessage: string;
  identityDocumentDigits: number;
} => {
  const {
    identityDocument,
    isIdentityDocumentValid,
    identityDocumentErrorMessage,
    identityDocumentDigits,
  } = getIdentityDocument({ country, inputEvent, documentType });
  let errorMessage = identityDocumentErrorMessage;

  if (!identityDocument) {
    errorMessage = I18N_STRINGS.REQUIRED_IDENTITY_DOCUMENT;
  } else if (
    !isIdentityDocumentValid &&
    identityDocument.length < identityDocumentDigits
  ) {
    errorMessage = I18N_STRINGS.INCOMPLETE_IDENTITY_DOCUMENT;
  }

  return {
    identityDocument,
    isIdentityDocumentValid,
    identityDocumentErrorMessage: errorMessage,
    identityDocumentDigits,
  };
};
